import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmployerRepresentativesService } from 'src/app/features/modules/employer-representatives/employer-representatives.service';
import { SharedCode } from 'src/app/services/gen/model/sharedCode';
import { AlertService } from '../ims-alerts/ims-alerts.service';
import { Utils } from '../utility/utils';

@Component({
    selector: 'app-naics-dialog',
    templateUrl: './naics-dialog.component.html',
    styleUrls: ['./naics-dialog.component.scss'],
    standalone: false
})
export class NaicsDialogComponent implements OnInit {
	naicsCode: string;
	naicsCategoryList: SharedCode[];
	filteredCodeList:  SharedCode[];
	naicsCodeList: SharedCode[];

	constructor(
		public dialogRef: MatDialogRef<NaicsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data,
		private empServ: EmployerRepresentativesService,
		private alert: AlertService,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.getInitData();
	}

	public lessThan() {
		return this.naicsCode?.length < 3;
	  }

	getInitData() {
		this.empServ.getNaicsSharedCodes().subscribe(
			(res) => {
				if (res && res.length) {
					this.naicsCategoryList = res
						.filter((item) => item.code.length === 2 || item.code.length === 3)
						.sort(Utils.sortSharedCodes);
						this.filteredCodeList = this.naicsCodeList = res.filter((item) => item.code.length > 5).sort(Utils.sortSharedCodes);
				}
			},
			(error) => {
				this.alert.error('Error happened while getting shared Nacis codes. Please contact system administrator.', error);
			}
		);
	}

	public changeInNaicsCode(){
		this.filteredCodeList = this.naicsCodeList;
				if(Utils.isNullCondition(this.naicsCode) || this.naicsCode.length >= 3) {
				this.naicsCode ? this._filter(this.naicsCode) : this.filteredCodeList.slice();
				}

	}

	displayNaicsCodeFunction(naicsCode) {
		if (typeof naicsCode === 'string' || naicsCode instanceof String) {
			return naicsCode;
		}
		// naicsCode is naicsCodeInfo
		if (naicsCode) {
			return naicsCode.code + '-' + naicsCode.description;
		}
	}


	private _filter(naics) {
		const filterValue = naics.toLowerCase();
		this.filteredCodeList = this.naicsCodeList?.filter((value) =>
			(value.description).toLowerCase().includes(filterValue)  || (value.code).includes(filterValue)
		);
		return this.filteredCodeList;
	}
}
